import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
declare var navigator;

/*
  Generated class for the GeolocalizationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GeolocalizationProvider {
  currentPosition: BehaviorSubject<any>;
  initialPosition: BehaviorSubject<any>;
  idWatcher: number = null;
  private options = {
    enableHighAccuracy: true,
    timeout: 6000,
    maximumAge: 0
  };

  constructor() {
    this.currentPosition = new BehaviorSubject<any>(null);
  }

  async getCurrentPosition() {
    return new Promise((success, error) => {
      navigator.geolocation.getCurrentPosition(
        position => {
          let pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.currentPosition.next(pos);
          success(pos);
        },
        this.errorHandler,
        this.options
      );
    });
  }

  async isBlocked() {
    return new Promise((success, error) => {
      // Default
      if (navigator.permission) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then(permission => success(permission.state === "denied"));
      }
      // Fallback - IOS
      else {
        navigator.geolocation.getCurrentPosition(
          position => {
            success(false);
          },
          function (error) {
            if (error.code == error.PERMISSION_DENIED) {
              success(true);
            }
            success(false);
          },
          this.options
        );
      }
    });
  }

  startWatcher() {
    if (this.idWatcher === null) {
      this.idWatcher = navigator.geolocation.watchPosition(
        pos => {
          let kmDistance = -1;

          if(this.currentPosition.value){
            kmDistance = calculateDistance(
              this.currentPosition.value.lat,
              this.currentPosition.value.lng,
              pos.coords.latitude,
              pos.coords.longitude
            );
          }

          if(kmDistance == -1 || kmDistance >= 1){

            let posData = {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
              kmDistance: kmDistance
            };
            this.currentPosition.next(posData);
          }
        },
        this.errorHandler,
        this.options
      );
    }
  }

  stopWatcher() {
    if (this.idWatcher !== null) {
      navigator.geolocation.clearWatch(this.idWatcher);
      this.idWatcher = null;
    }
  }

  private errorHandler(err) {
    console.log(err);
  }
}

//This uses the ‘haversine’ formula to calculate the great-circle distance between two points
function calculateDistance(lat1, lon1, lat2, lon2) {
  let R = 6371; // Radius of the earth in km 
  let dLat = toRad(lat2 - lat1);  // deg2rad below
  let dLon = toRad(lon2 - lon1);

  lat1 = toRad(lat1);
  lat2 = toRad(lat2);

  let a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);

  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c;
  return d;

  // Converts numeric degrees to radians
  function toRad(Value) {
    return Value * (Math.PI / 180);
  }
}
